import React from 'react';
import { MyPortfolioCapsuleContentProps } from 'widgets/myPortfolioCapsules/MyPortfolioCapsuleWidgetStrategy';
import { CorporateActionsCapsuleContent } from 'widgets/corpActions/capsule/components/CorporateActionsCapsuleContent';
import { useCorporateActionsStreamedData } from 'widgets/corpActions/store/data/hooks';
import './CorporateActionsCapsule.scss';
import { useMyPortfolioCapsuleConfigSlice } from 'widgets/myPortfolioCapsules/store/config/configSlice';
import { CorporateActionsCapsuleConfigState } from 'widgets/corpActions/capsule/store/CorporateActionsCapsuleConfigState';
import { CorporateActionsWidgetConfigState } from 'widgets/corpActions/widget/store/config/CorporateActionsWidgetConfigState';
import { useEarningsAftMktEnricher } from 'widgets/corpActions/store/data/earningsAftMktOnTMinus1.ts';

export function CorporateActionsCapsuleMyPortfolioCapsuleContent(
    props: MyPortfolioCapsuleContentProps
) {
    const { symbol } = props;
    const { config } =
        useMyPortfolioCapsuleConfigSlice<CorporateActionsCapsuleConfigState>();

    const data = useCorporateActionsStreamedData(
        symbol,
        config as CorporateActionsWidgetConfigState
    );

    const { enrichedSymbolEvents } = useEarningsAftMktEnricher(
        data?.events ?? []
    );

    return (
        <CorporateActionsCapsuleContent
            config={config}
            data={enrichedSymbolEvents}
            symbol={symbol}
        />
    );
}
